// src/components/MatrimonyForm.js
import React, { useState, useEffect } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  Heading,
  Textarea,
  SimpleGrid,
  useToast,
  Text,
  Divider,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  useDisclosure,
} from '@chakra-ui/react';
import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';
import { callApi } from '../api';
import axios from 'axios';

const API_BASE_URL = 'https://api-amg2dwk5ga-uc.a.run.app';

const MatrimonyForm = () => {
  const [formData, setFormData] = useState({
    member_id: '', // Added member_id to state
    name: '',
    father_name: '',
    mother_name: '',
    age: '',
    date_of_birth: '',
    gender: 'Male',
    education: '',
    current_location: '',
    height: '',
    complexion: '',
    gotra: '',
    mother_gotra: '',
    occupation: '',
    income: '',
    work_location: '',
    father_occupation: '',
    phone_number: '',
    siblings: '',
    preferences: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    onOpen();
  }, [onOpen]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/matrimony/create`, formData);
      toast({ title: 'Profile Created', description: response.message, status: 'success' });
    } catch (error) {
      toast({ title: 'Creation Failed', description: error.message, status: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>A new initiative for empowerment of marriage relations of Bagda Brahmin Samaj – Appeal to join the matrimonial site</ModalHeader>
          <ModalBody>
            <VStack align="center" textAlign="justify" spacing={4}>
            <Text>
            Among the diverse societies of India, Bagda Brahmin Samaj is such a proud community, which has a long history of its own cultural heritage, religious traditions and social unity. At present, when technology has brought changes in every sphere of life, a serious problem has emerged before our society – that is the difficulties in arranging marriages for children.
            </Text>
            <Text>&nbsp;</Text>
            <Text>
            In Bagda Brahmin Samaj, finding a suitable life partner for marriageable young men and women is becoming a challenge. At some places there is a lack of information, at other places there is a lack of communication. Even though there are eligible grooms and brides in one corner of the society, the relatives living in the other corner are not able to know about them. As a result, the age of marriage keeps passing, and the anxiety in the minds of parents keeps increasing.
            </Text>
            <Text>&nbsp;</Text>
            <Text>
            Keeping these challenges in mind, under a historic and commendable initiative of Bagda Brahmin Samaj, the society's own matrimonial website has been prepared. This website is an effort to connect all the people of our society on a digital platform, so that eligible and suitable relationships can be found within the society itself.
            </Text>
            <Text>&nbsp;</Text>
            <Text>
            Features of this matrimonial site:
            <Text>&nbsp;</Text>
            1. Dedicated to the society - This site has been created only for the Bagda Brahmin community, so that relationships can be fixed only between the young men and women of our society.
            <Text>&nbsp;</Text>
            2. Detailed information - Complete information about the bride and groom is being provided about education, occupation, family, gotra, date of birth, horoscope etc.
            <Text>&nbsp;</Text>
            3. Safe and confidential - All data is kept safe, and your privacy is taken care of.
            <Text>&nbsp;</Text>
            4. User friendly - The website is very easy to use. People of all ages of the society can use it without any difficulty.
            <Text>&nbsp;</Text>
            5. Online and offline support - Samaj volunteers will always be available for technical support.
            <Text>&nbsp;</Text>
            </Text>
            <Text>
            Humble appeal to the community members:
            <Text>&nbsp;</Text>
            Our heartfelt appeal to all the brothers and sisters, mothers and fathers, youth of the community is to definitely join this matrimonial website. Get the profiles of eligible sons and daughters of your family made on it, encourage other members as well. The more members participate in this initiative, the more we will get an opportunity to know about each other and the network of marriage relations will be strengthened.
            <Text>&nbsp;</Text>
            This initiative is not limited to marriage only, it is a symbol of our unity, awareness and self-respect of the society. Let us all together make this effort successful and make our society self-reliant in an important field like marriage.
            <Text>&nbsp;</Text>
            Call of the future
            <Text>&nbsp;</Text>
            Today when everything is happening through the internet - education, business, communication, banking - then using technology in a sacred and social work like marriage is the need of the hour. This is not just a convenience, but a symbol of social strength and awareness.
            <Text>&nbsp;</Text>
            It is our collective responsibility that every member of the Bagda Brahmin community should become a part of this campaign. This small step can bring a big change for the bright future of our children, unity of society and to keep traditions alive.
            <Text>&nbsp;</Text>
            Solution is possible only with joint efforts. Let us give a new direction to the society in this digital age.           
          </Text>
          </VStack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="brand" onClick={onClose}>
              Okay
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    <Box p={8} maxWidth="800px" borderWidth={1} borderRadius={8} boxShadow="lg" mx="auto" my={10}>
      <VStack as="form" spacing={6} onSubmit={handleSubmit}>
        <Heading>Create Your Matrimony Profile</Heading>
        <Text color="gray.600">Please enter your details. Your Member ID is required for verification.</Text>
        
        {/* --- ADD THIS NEW FIELD AT THE TOP --- */}
        <FormControl isRequired>
          <FormLabel>Member ID</FormLabel>
          <Input 
            name="member_id" 
            placeholder="Enter the Member ID you received after approval" 
            onChange={handleChange} 
            value={formData.member_id}
            />
        </FormControl>

        <Divider />

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} w="full">
          <FormControl isRequired><FormLabel>Full Name</FormLabel><Input name="name" onChange={handleChange} /></FormControl>
          <FormControl isRequired><FormLabel>Father's Name</FormLabel><Input name="father_name" onChange={handleChange} /></FormControl>
          <FormControl isRequired><FormLabel>Mother's Name</FormLabel><Input name="mother_name" onChange={handleChange} /></FormControl>
          <FormControl isRequired>
            <FormLabel>Gender</FormLabel>
            <Select name="gender" value={formData.gender} onChange={handleChange}>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </Select>
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Date of Birth</FormLabel>
            <Input type="date" name="date_of_birth" onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Education</FormLabel>
            <Input name="education" placeholder="e.g., B.Tech, MBA" onChange={handleChange} />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Current Location</FormLabel>
            <Input name="current_location" placeholder="e.g., Jaipur, Rajasthan" onChange={handleChange} />
          </FormControl>
          <FormControl isRequired><FormLabel>Height (e.g., 5ft 8in)</FormLabel><Input name="height" onChange={handleChange} /></FormControl>
          <FormControl isRequired><FormLabel>Complexion</FormLabel><Input name="complexion" onChange={handleChange} /></FormControl>
          <FormControl isRequired><FormLabel>Gotra</FormLabel><Input name="gotra" onChange={handleChange} /></FormControl>
          <FormControl isRequired><FormLabel>Mother's Gotra</FormLabel><Input name="mother_gotra" onChange={handleChange} /></FormControl>
          <FormControl isRequired><FormLabel>Occupation</FormLabel><Input name="occupation" onChange={handleChange} /></FormControl>
          <FormControl isRequired><FormLabel>Annual Income (e.g., 10 LPA)</FormLabel><Input name="income" onChange={handleChange} /></FormControl>
          <FormControl isRequired><FormLabel>Work Location</FormLabel><Input name="work_location" onChange={handleChange} /></FormControl>
          <FormControl isRequired><FormLabel>Father's Occupation</FormLabel><Input name="father_occupation" onChange={handleChange} /></FormControl>
          <FormControl isRequired><FormLabel>Contact Phone Number</FormLabel><Input type="tel" name="phone_number" onChange={handleChange} /></FormControl>
          <FormControl isRequired><FormLabel>Siblings (e.g., 1 brother, 1 sister)</FormLabel><Input name="siblings" onChange={handleChange} /></FormControl>
        </SimpleGrid>

        <FormControl>
          <FormLabel>Any Preferences</FormLabel>
          <Textarea name="preferences" placeholder="Describe your partner preferences" onChange={handleChange} />
        </FormControl>

        <Button type="submit" colorScheme="brand" width="full" mt={4} isLoading={isLoading}>
          Create Profile
        </Button>
      </VStack>
    </Box>
    </>
  );
};

export default MatrimonyForm;